(function() {
  document.addEventListener('DOMContentLoaded', function() {
    verbrauchsrechner();

    document.addEventListener('shopify:section:load', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:section:unload', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:section:select', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:section:deselect', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:section:reorder', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:block:select', function() {
      verbrauchsrechner();
    });

    document.addEventListener('shopify:block:deselect', function() {
      verbrauchsrechner();
    });
  });

  function verbrauchsrechner() {
    var verbrauchsrechnerElement = document.getElementById('verbrauchsrechner');
    if (verbrauchsrechnerElement) {
      var step1 = verbrauchsrechnerElement.querySelector('.step1 select').value;
      var step2 = verbrauchsrechnerElement.querySelector('.step2 select').value;
      var step3 = verbrauchsrechnerElement.querySelector('.step3 select').value;

      var calculateResult = function() {
        var quantity = verbrauchsrechnerElement.querySelector('.step0 input').value;
        var result = (quantity * (parseInt(verbrauchsrechnerElement.dataset[step1 + '_' + step2 + '_' + step3]) / 1000)).toFixed(2).replace('.', ',');
        verbrauchsrechnerElement.querySelector('.result').innerHTML = '<span>= ' + result + 'kg</span>';
      };

      verbrauchsrechnerElement.querySelector('.step0 input').addEventListener('keyup', calculateResult);
      verbrauchsrechnerElement.querySelector('.step1 select').addEventListener('change', function(e) {
        step1 = e.target.value;
        calculateResult();
      });
      verbrauchsrechnerElement.querySelector('.step2 select').addEventListener('change', function(e) {
        step2 = e.target.value;
        calculateResult();
      });
      verbrauchsrechnerElement.querySelector('.step3 select').addEventListener('change', function(e) {
        step3 = e.target.value;
        calculateResult();
      });
    }
  }
})();
